import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ spacing }) => ({
  container: {
    "&::-webkit-scrollbar": { display: "none" },
    "-ms-overflow-style": "none",
    height: "100%",
    marginBottom: spacing(-4),
    overflow: "auto",
    scrollbarWidth: "none",
    width: "100%",
  },
  icon_wrapper: {
    color: "#D9DCF0",
    display: "flex",
  },
  scroller: {
    position: "relative",
    width: "100%",
  },
  text: {
    color: "#757575",
    fontSize: spacing(4),
    lineHeight: "normal",
    padding: "48px 0",
    textAlign: "center",
    maxWidth: 960,
  },
  wrapper: {
    display: "flex",
    margin: "0 auto 48px",
    paddingTop: spacing(4),
    width: "75%",
  },
}));
